import { lazy, Suspense } from 'react'

import { LoadingTurbo } from 'atoms'

import { OpportunitiesFilterScreenComponent } from './OpportunitiesFilterScreen.types'
import { useOpportunitiesFilterScreen } from './useOpportunitiesFilterScreen'

const OpportunitiesFilterScreenDesktop = lazy(() => import('./OpportunitiesFilterScreen.desktop'))

export const OpportunitiesV3FilterScreen: OpportunitiesFilterScreenComponent = ({ navigation }) => {
  const opportunitiesFilterScreen = useOpportunitiesFilterScreen({ navigation })

  const Screen = OpportunitiesFilterScreenDesktop

  return (
    <Suspense fallback={<LoadingTurbo />}>
      <Screen {...opportunitiesFilterScreen} />
    </Suspense>
  )
}
